module.exports = __webpack_public_path__ + "img/company_info.edb968b8.svg";